/**
 * Flash-E - Technical Interview Flashcards
 * Copyright (c) 2025 Steve Crittenden
 * Licensed under AGPL-3.0
 *
 * https://github.com/critter/flash-e
 */

import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AppProvider } from './contexts/AppContext';
import Navigation from './components/Navigation';
import DeckBrowser from './components/DeckBrowser';
import DeckEditor from './components/DeckEditor';
import CardEditor from './components/CardEditor';
import DeckPlayer from './components/DeckPlayer';
import AISettings from './components/AISettings';
import Progress from './components/Progress';
import ErrorBoundary from './components/ErrorBoundary';
import Footer from './components/Footer';
import './App.css';

const AppContent: React.FC = () => {
  return (
    <div className="app flex flex-col min-h-screen">
      <Navigation />
      <main className="main-content flex-grow">
        <Routes>
          <Route path="/" element={<DeckBrowser />} />
          <Route path="/deck/:deckId/edit" element={<DeckEditor />} />
          <Route path="/deck/:deckId/card/:cardId/edit" element={<CardEditor />} />
          <Route path="/deck/:deckId/card/new" element={<CardEditor />} />
          <Route path="/deck/:deckId/play" element={<DeckPlayer />} />
          <Route path="/play" element={<DeckPlayer />} />
          <Route path="/progress" element={<Progress />} />
          <Route path="/settings" element={<AISettings />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <AppProvider>
        <AppContent />
      </AppProvider>
    </ErrorBoundary>
  );
};

export default App;